document.addEventListener('DOMContentLoaded', () => {
  const galleries = document.querySelectorAll('media-gallery');

  galleries.forEach((gallery) => {
    const slider = gallery.querySelector('.product__media-list');
    const slides = gallery.querySelectorAll('.product__media-item');
    const dotsWrap = gallery.querySelector('[data-gallery-dots]');
    const dots = dotsWrap ? dotsWrap.querySelectorAll('.product-gallery-dot') : [];

    if (!slider || !slides.length || !dots.length) return;

    const setActiveDot = (index) => {
      dots.forEach((dot, i) => {
        dot.classList.toggle('is-active', i === index);
      });
    };

    const getActiveIndex = () => {
      const sliderLeft = slider.scrollLeft;
      let closestIndex = 0;
      let closestDistance = Infinity;

      slides.forEach((slide, index) => {
        const distance = Math.abs(slide.offsetLeft - sliderLeft);
        if (distance < closestDistance) {
          closestDistance = distance;
          closestIndex = index;
        }
      });

      return closestIndex;
    };

    dots.forEach((dot) => {
      dot.addEventListener('click', () => {
        const index = Number(dot.dataset.index);
        const targetSlide = slides[index];
        if (!targetSlide) return;

        slider.scrollTo({
          left: targetSlide.offsetLeft,
          behavior: 'smooth',
        });

        setActiveDot(index);
      });
    });

    let scrollTimeout;
    slider.addEventListener('scroll', () => {
      window.clearTimeout(scrollTimeout);
      scrollTimeout = window.setTimeout(() => {
        setActiveDot(getActiveIndex());
      }, 50);
    });

    setActiveDot(0);
  });
});